import React from "react";
import { useNavigate } from "react-router-dom";
import { Package, ExternalLink } from "lucide-react";

const StoreFrontFooter = () => {
  const navigate = useNavigate();
  
  return (
    <footer className="bg-white dark:bg-black border-t border-gray-200 dark:border-gray-800 py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="flex flex-col items-center justify-center space-y-8">
            {/* CTA Section */}
            <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md">
                <button 
                    onClick={() => navigate(`/track`)}
                    className="flex-1 flex items-center justify-center gap-2 bg-gray-100 dark:bg-gray-900 text-black dark:text-white font-bold px-6 py-3.5 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors"
                >
                    <Package className="w-5 h-5" />
                    Track an Order
                </button>
                <a 
                    href="https://paymeo.co"
                    target="_blank"
                    rel="noreferrer"
                    className="flex-1 flex items-center justify-center gap-2 bg-blue-600 text-white font-bold px-6 py-3.5 rounded-full hover:bg-blue-700 shadow-lg shadow-blue-600/20 transition-all active:scale-95"
                >
                    Create your Store <ExternalLink className="w-4 h-4" />
                </a>
            </div>

            {/* Branding & Copyright */}
            <div className="text-center space-y-2">
                 <div className="flex items-center justify-center gap-2 text-gray-400 dark:text-gray-500 text-sm font-medium">
                    <span>Powered by</span>
                    <span className="font-bold text-black dark:text-white flex items-center gap-1">
                        Paymeo
                    </span>
                 </div>
                 <p className="text-xs text-gray-400 dark:text-gray-600">
                    © {new Date().getFullYear()} Paymeo Inc. All rights reserved.
                 </p>
            </div>
        </div>

      </div>
    </footer>
  );
}

export default StoreFrontFooter;